import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Smartphone, Download } from 'lucide-react';
export function FinalCTA() {
  return <footer className="relative pt-16 pb-12 md:pt-24 md:pb-16 px-4 md:px-6 lg:px-8 border-t border-white/10 bg-[#050505] overflow-hidden" data-id="element-74">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-gradient-to-t from-cyan-900/20 to-transparent blur-[100px] pointer-events-none" data-id="element-75" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-77">
          <div className="inline-flex items-center gap-3 bg-green-500/10 border border-green-500/20 rounded-full px-6 py-3 mb-8 shadow-[0_0_20px_rgba(34,197,94,0.1)]" data-id="element-78">
            <ShieldCheck className="w-6 h-6 text-green-400" data-id="element-79" />
            <span className="text-green-50 font-bold tracking-wide" data-id="element-80">
              Garantía de 7 Días — 100% Libre de Riesgos
            </span>
          </div>

          <h2 className="font-heading text-4xl md:text-6xl font-black text-white mb-6 leading-tight tracking-tight" data-id="element-81">
            No dejes que tu negocio <br className="hidden md:block" data-id="element-82" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400" data-id="element-83">
              se hunda en el desorden.
            </span>
          </h2>

          <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-2xl mx-auto font-light" data-id="element-84">
            Mientras tú sigues adivinando cuánto cobrar, tu competencia ya usa
            sistemas automatizados para proteger su ganancia. Toma el control
            hoy.
          </p>

          <motion.a href="#comprar" whileHover={{
          scale: 1.03,
          y: -2
        }} whileTap={{
          scale: 0.97
        }} className="relative flex flex-col items-center justify-center w-full sm:w-auto px-10 py-5 bg-gradient-to-r from-green-500 to-cyan-500 rounded-2xl shadow-[0_0_40px_-10px_rgba(34,197,94,0.6)] hover:shadow-[0_0_60px_-15px_rgba(34,197,94,0.8)] transition-all duration-300 border border-white/20 overflow-hidden group cursor-pointer text-decoration-none mb-12" data-id="element-85">
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-86" />

            <span className="relative z-10 flex items-center justify-center gap-3 text-2xl md:text-3xl font-black text-white tracking-tight drop-shadow-md w-full text-center" data-id="element-87">
              <Download className="w-7 h-7 animate-bounce" data-id="element-88" />
              ADQUIRIR MI SISTEMA ELITE
            </span>

            <span className="relative z-10 mt-2 text-sm md:text-base font-bold text-green-50 bg-black/30 px-5 py-1.5 rounded-full backdrop-blur-md border border-white/10" data-id="element-89">
              Desde $24.99 (Pago Único)
            </span>
          </motion.a>

          <div className="mb-16" data-id="element-90">
            <p className="text-gray-500 text-sm mb-4 font-medium uppercase tracking-widest" data-id="element-91">
              Pago 100% Seguro en Venezuela
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-gray-400 bg-white/5 py-4 px-8 rounded-2xl border border-white/5 inline-flex" data-id="element-92">
              <div className="flex items-center gap-2" data-id="element-93">
                <Smartphone className="w-6 h-6 text-green-400" data-id="element-94" />
                <span className="font-semibold text-white" data-id="element-95">Pago Móvil</span>
              </div>
              <span className="text-white/20 hidden sm:block" data-id="element-96">|</span>

              <div className="flex items-center gap-2" data-id="element-97">
                <svg className="w-6 h-6 text-yellow-400" viewBox="0 0 24 24" fill="currentColor" data-id="element-98">
                  <path d="M11.999 0L17.58 5.582l-2.028 2.028-3.553-3.553-3.553 3.553-2.028-2.028L11.999 0zm0 16.516l-4.516-4.516-2.028 2.028 6.544 6.544 6.544-6.544-2.028-2.028-4.516 4.516zm9.58-10.934l2.028 2.028-6.544 6.544-2.028-2.028 6.544-6.544zm-19.16 0l2.028-2.028 6.544 6.544-2.028 2.028-6.544-6.544z" data-id="element-99" />
                </svg>
                <span className="font-semibold text-white" data-id="element-100">Binance</span>
              </div>

              <span className="text-white/20 hidden sm:block" data-id="element-101">|</span>
              <div className="flex items-center gap-2" data-id="element-102">
                <CreditCard className="w-6 h-6 text-cyan-400" data-id="element-103" />
                <span className="font-semibold text-white" data-id="element-104">Tarjetas</span>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-white/10 w-full flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-105">
            <p className="text-gray-500 text-sm font-medium" data-id="element-106">
              © {new Date().getFullYear()}{' '}
              <span className="text-white" data-id="element-107">Digital Solvex</span>. Todos los
              derechos reservados.
            </p>
            <div className="flex items-center gap-6 text-sm text-gray-500" data-id="element-108">
              <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-109">
                Términos de Servicio
              </a>
              <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-110">
                Política de Privacidad
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>;
}